<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Transit Miles'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  export default {
    name: 'TransitMileSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Origin', prop: (location) => location.originLocation ? location.originLocation.name : '' },
          { header: 'Origin State', prop: (location) => location.originLocation ? location.originLocation.subdivision : '' },
          { header: 'Origin Country', prop: (location) => location.originLocation && location.originLocation.country && location.originLocation.country.code },
          { header: 'Destination', prop: (location) => location.destinationLocation ? location.destinationLocation.name : '' },
          { header: 'Destination State', prop: (location) => location.destinationLocation ? location.destinationLocation.subdivision : '' },
          { header: 'Destination Country', prop: (location) => location.destinationLocation && location.destinationLocation.country && location.destinationLocation.country.code },
          { header: 'Distance', prop: 'distance', numericalField: true }
        ],
        loading: false,
        tableData: [],
        entityName: 'transit-miles',
        editEntityScreen: 'Admin - Edit/View Transit Mile',
        shouldSearchForExactMatch: true,
        orderBy: 'originLocation'
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// TransitMileSearchResults.vue?197d3e80